import React, { Component } from 'react';

import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import styles from './styles';
import ControlObjective from './ControlObjective'
import ControlMonthObjective from './ControlMonthObjective'
import PasswordField from 'material-ui-password-field'
import MaterialRadioButton from '../../../../helpers/RadioButton'
import {token} from '../../../../common/constants'
import moment from 'moment'
import 'moment/locale/es'  
moment.locale('es')

class Control extends Component {

    
    constructor(props) {
        super(props);
        //console.log('control',props.data)
        this.handleBack = this.handleBack.bind(this);
        this.handleBackControl = this.handleBackControl.bind(this);
        this.infoAutoComplete = this.infoAutoComplete.bind(this);
        
        this.state = {
            error:false,
            textError:["","Ingrese Token", "Token Invalido"],
            indexError:0,
            tokenValue:"",
            data:this.props.data,
            open:false,
            control:true,
            selectRange:false,
            openDaily:false,
            openMonth:false
        }
        
    }

    handleBack =()=>{
        this.props.infoControl()
    }

    handleFieldChange = (field, value) => {
        this.setState({
            tokenValue:value
        })
    }
    

    handleOpen =()=>{
        const {tokenValue}=this.state
        if(tokenValue===""){
            this.setState({
                indexError:1
            })
        }else if(tokenValue!==token){
            this.setState({
                indexError:2
            })
        }else{
            this.setState({
                indexError:0,
                open:true
            })
        }
    }
    infoAutoComplete=(e,x)=>{
        if(e==="diario"){
            this.setState({
                openDaily:true,
                openMonth:false,
                selectRange:true
            })
        }else{
            this.setState({
                openDaily:false,
                openMonth:false,
                selectRange:true
            })
        }
        
    }
    handleBackControl=()=>{
        this.setState({
            open:false,
            openDaily:false,
            openMonth:false,
            selectRange:false
        })
    }
    
    render() {
        const {classes}= this.props
        const {textError, indexError, open, selectRange, openDaily, openMonth}=this.state
       
        if(open===false){
            return(
                <Grid
                    container
                    spacing={1}
                >
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"left"}}
                    >
                        <Button onClick={this.handleBack}>
                            <ArrowBackIosIcon/>
                        </Button>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center"}}
                    >
                       <Typography variant="h4" className={classes.colorMov}>Seleccione Rango de Fecha a Modificar</Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center"}}
                    >
                        <MaterialRadioButton list={[{id:0,nombre:"diario"}, {id:1,nombre:"mensual"}]}
                            label="Seleccione Rangos de Fecha" placeholder="Seleccione Rangos de Fecha"
                            infoAutoComplete={this.infoAutoComplete}/>
                    </Grid>
                    {selectRange?
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}
                                style={{textAlign:"center"}}
                            >
                                <PasswordField
                                    floatingLabelText="Enter your password"
                                    onChange={event =>
                                        this.handleFieldChange('name', event.target.value)
                                    }
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}
                                style={{textAlign:"center"}}
                            >
                                <Typography style={{color:"red"}}>{textError[indexError]}</Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}
                                style={{textAlign:"center"}}
                            >
                                <Button onClick={this.handleOpen}>
                                    <Typography varian="button" className={classes.colorMov}>Ingresar</Typography>
                                </Button>
                            </Grid>
                        </Grid>:
                        null
                        
                    }
                    
                    
                </Grid>
            )
        }else{
            if(openDaily===true){
                return(
                    <Grid
                        container
                        spacing={1}
                    >
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            xl={12}
                            //style={{textAlign:"center"}}
                        >
                            <ControlObjective handleBackControl={this.handleBackControl} data={this.state.data} />
                        </Grid>
                    </Grid>
                )
            }else{
                return(
                    <ControlMonthObjective handleBackControl={this.handleBackControl} data={this.state.data} />
                )
            }
            
        }
        
    }
}



//export default (Movistar);

export default compose(withStyles(styles))(Control);


// WEBPACK FOOTER //
// ./src/layouts/components/content/Control/index.jsx